import React from 'react';
import { FormFeedback } from 'Components/frameworks/form-feedback/FormFeedback';
import type { FormErrorsType } from './participants.validator';
type Props = {
  className?: string;
  config: {
    departureDateErrorMessage?: string;
    errorMaxGuestsLabel?: string;
  };
  errors: FormErrorsType;
  isSubmitted: boolean;
};
export const ParticipantsErrors = ({ className, config, errors, isSubmitted }: Props) => {
  const { maxPax, departureDate, birthdays, birthdaysErrorMessage } = errors;

  if (maxPax) {
    return (
      <FormFeedback
        className={className}
        hasAutoScroll
        isError
        message={config.errorMaxGuestsLabel}
      />
    );
  }

  if (isSubmitted && departureDate) {
    return (
      <FormFeedback
        className={className}
        hasAutoScroll
        isError
        message={config.departureDateErrorMessage}
      />
    );
  }

  if (isSubmitted && birthdays) {
    return (
      <FormFeedback className={className} hasAutoScroll isError message={birthdaysErrorMessage} />
    );
  }

  return null;
};
